import type { PrimitiveBrowseData, PrimitiveListItem } from "#primitive-browse-types";

const BUCKETS = [
  { compoundCountLabel: "81+ compounds", key: "81-plus", min: 81 },
  { compoundCountLabel: "41–80 compounds", key: "41-80", min: 41 },
  { compoundCountLabel: "21–40 compounds", key: "21-40", min: 21 },
  { compoundCountLabel: "11–20 compounds", key: "11-20", min: 11 },
  { compoundCountLabel: "6–10 compounds", key: "6-10", min: 6 },
  { compoundCountLabel: "5 compounds", key: "5", min: 5 },
  { compoundCountLabel: "4 compounds", key: "4", min: 4 },
  { compoundCountLabel: "3 compounds", key: "3", min: 3 },
  { compoundCountLabel: "2 compounds", key: "2", min: 2 },
  { compoundCountLabel: "1 compound", key: "1", min: 1 },
] as const;

/** Build-time grouping; custom corpus filters also use this on the small bundled result set. */
export function groupPrimitiveBuckets(items: readonly PrimitiveListItem[]): PrimitiveBrowseData {
  const primitives = items
    .filter((item) => item.compounds.length > 0)
    .sort((a, b) => b.compounds.length - a.compounds.length || a.glyph.localeCompare(b.glyph));
  const buckets = BUCKETS.map(({ min: _, ...bucket }) => ({ ...bucket, glyphs: [] as string[] }));
  for (const item of primitives) {
    const index = BUCKETS.findIndex((bucket) => item.compounds.length >= bucket.min);
    buckets[index]?.glyphs.push(item.glyph);
  }
  return { buckets: buckets.filter((bucket) => bucket.glyphs.length > 0), primitives };
}
